/**********
NHL LIVETRACKER REDUCERS
**********/

let nhlInitStateObj = {
    snClips: [],
    ighClips: [],
    initVideoFetch: true,
    videoError: false,
    currentVideoTab: '',
    activeVideoPlayers: [],
    prevent_video: {},
}

export const nhlLivetracker = (state = nhlInitStateObj, action) => {
    switch (action.type) {
        case 'ROUTE_CHANGE':
            return nhlInitStateObj

        case 'NHL_VIDEO_DATA_RECEIVED':
            return {
                ...state,
                snClips: action.snClipsData,
                ighClips: action.ighClipsData,
            }

        case 'VIDEO_FEED_REQUEST_COMPLETE':
            return {
                ...state,
                initVideoFetch: false,
                videoError: false,
            }

        case 'RESET_INIT_VIDEO_FEED_REQUEST':
        case 'VIDEO_INIT_FEED_REQUEST':
            return {
                ...state,
                initVideoFetch: true,
            }

        case 'VIDEO_FEED_ERROR':
            return {
                ...state,
                videoError: true,
                initVideoFetch: false,
            }

        case 'CURRENT_VIDEO_TAB':
            return {
                ...state,
                currentVideoTab: action.tab,
            }

        case 'ADD_VIDEO_PLAYER':
            return {
                ...state,
                activeVideoPlayers: [...state.activeVideoPlayers, action.id],
            }

        case 'REMOVE_VIDEO_PLAYER': {
            let newVideoArray = []
            for (let i = 0; i < state.activeVideoPlayers.length; i++) {
                if (state.activeVideoPlayers[i] !== action.id) {
                    newVideoArray.push(state.activeVideoPlayers[i])
                }
            }
            return {
                ...state,
                activeVideoPlayers: newVideoArray,
            }
        }

        case 'PREVENT_VIDEO_NHL':
            return {
                ...state,
                prevent_video: action.transition,
            }

        default:
            return state
    }
}
